import React from 'react';
import { shape, string } from 'prop-types';
import {
  FileDoneOutlined,
  FileExcelOutlined,
  FileExclamationOutlined,
  FileOutlined,
  FileGifOutlined,
  FileImageOutlined,
  FileJpgOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileSyncOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons';

const FORMAT_ICON = {
  xls: FileExcelOutlined,
  xlsx: FileExcelOutlined,
  gif: FileGifOutlined,
  png: FileImageOutlined,
  bmp: FileImageOutlined,
  tif: FileImageOutlined,
  tiff: FileImageOutlined,
  jpg: FileJpgOutlined,
  jpeg: FileJpgOutlined,
  numbers: FileExcelOutlined,
  pages: FileWordOutlined,
  key: FilePptOutlined,
  pdf: FilePdfOutlined,
  ppt: FilePptOutlined,
  pptx: FilePptOutlined,
  txt: FileTextOutlined,
  csv: FileTextOutlined,
  json: FileTextOutlined,
  xml: FileTextOutlined,
  unknown: FileUnknownOutlined,
  doc: FileWordOutlined,
  odt: FileWordOutlined,
  ods: FileWordOutlined,
  odp: FileWordOutlined,
  docx: FileWordOutlined,
  rtf: FileWordOutlined,
  zip: FileZipOutlined,
  rar: FileZipOutlined,
  tar: FileZipOutlined,
  gz: FileZipOutlined,
  '7z': FileZipOutlined,
  heic: FileImageOutlined,
};

const STATUS_ICON = {
  done: FileDoneOutlined,
  error: FileExclamationOutlined,
  uploading: FileSyncOutlined,
};

const FileIcon = ({ status = null, format = null, style = {} }) => {
  const Renderer = STATUS_ICON[status] || FORMAT_ICON[format] || FileOutlined;

  return <Renderer style={style} />;
};

FileIcon.propTypes = {
  status: string,
  format: string,
  style: shape({}),
};

export default FileIcon;
